import { render, staticRenderFns } from "./AlButton.vue?vue&type=template&id=fa842206&"
import script from "./AlButton.vue?vue&type=script&lang=js&"
export * from "./AlButton.vue?vue&type=script&lang=js&"
import style0 from "./AlButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports